import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyState = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 396.741,
	height: 243.967,
	viewBox: "0 0 396.741 243.967",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_10199",
		"data-name": "Group 10199",
		transform: "translate(-747.46 -356.527)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_24046",
				"data-name": "Path 24046",
				d: "M872.963,803.528s-35.606-61.282-17.8-101.061c20.762-46.39,67.937-67.85,116.832-60.207,45.267,7.076,33.013-34.8,72.618-61.9,84.715-57.973,186.638,23.2,177.928,97.049-7.567,64.162,44.642,64.116,15.4,127.2Z",
				transform: "translate(-102.715 -204.109)",
				fill: "#fde7ee"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_647",
				"data-name": "Group 647",
				transform: "translate(799.835 466.818)",
				children: [
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_258",
						"data-name": "Group 258",
						transform: "translate(172.966 0)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_67",
								"data-name": "Rectangle 67",
								width: 104.205,
								height: 36.452,
								rx: 18.226,
								transform: "translate(0.135)",
								fill: "#fff"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_1127",
								"data-name": "Path 1127",
								d: "M-78.666-16.732c-10.981-1.921-12.519-5.324-10.306-6.559,4.242-2.367,25.587-7.621,38.762-1.338,2.536,1.209,1.174,3.275,1.609,5.552.032,7.695,0,13.638,0,15.441a7.864,7.864,0,0,1,0,1.4.526.526,0,0,1-.095.448c-.967-.058-4.207.016-21.115.016-10.575,0-55.814,0-83.536-.075-.036,0-.288-9.868,0-9.756C-142.967-1.11-29.634-7.687-78.666-16.732Z",
								transform: "translate(153.483 38.479)",
								fill: "#edf0fa"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_68",
								"data-name": "Rectangle 68",
								width: 11.974,
								height: 1.996,
								rx: .998,
								transform: "translate(10.558 6.218)",
								fill: "#707071"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_69",
								"data-name": "Rectangle 69",
								width: 3.326,
								height: .333,
								rx: .166,
								transform: "translate(14.882 10.541)",
								fill: "#b0d7ee"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_70",
								"data-name": "Rectangle 70",
								width: 10.976,
								height: 1.663,
								rx: .831,
								transform: "translate(12.886 14.532)",
								fill: "#002c76"
							}),
							/* @__PURE__ */ _jsx("circle", {
								id: "Ellipse_20",
								"data-name": "Ellipse 20",
								cx: .665,
								cy: .665,
								r: .665,
								transform: "translate(9.56 14.865)",
								fill: "#00d6c4"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_71",
								"data-name": "Rectangle 71",
								width: 87.474,
								height: .665,
								rx: .333,
								transform: "translate(6.899 21.85)",
								fill: "#b0d7ef"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_72",
								"data-name": "Rectangle 72",
								width: 11.974,
								height: 1.996,
								rx: .998,
								transform: "translate(44.816 6.218)",
								fill: "#6f7070"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_73",
								"data-name": "Rectangle 73",
								width: 3.326,
								height: .333,
								rx: .166,
								transform: "translate(49.14 10.541)",
								fill: "#b0d7ee"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_74",
								"data-name": "Rectangle 74",
								width: 9.978,
								height: 1.663,
								rx: .831,
								transform: "translate(45.814 14.2)",
								fill: "#002c76"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_75",
								"data-name": "Rectangle 75",
								width: 2.993,
								height: .998,
								rx: .499,
								transform: "translate(49.472 16.528)",
								fill: "#bac3d0"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_76",
								"data-name": "Rectangle 76",
								width: 11.974,
								height: 1.996,
								rx: .998,
								transform: "translate(79.074 6.218)",
								fill: "#707070"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_77",
								"data-name": "Rectangle 77",
								width: 3.326,
								height: .333,
								rx: .166,
								transform: "translate(83.397 10.541)",
								fill: "#b0d7ef"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_78",
								"data-name": "Rectangle 78",
								width: 9.978,
								height: 1.663,
								rx: .831,
								transform: "translate(80.071 14.2)",
								fill: "#002c76"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_79",
								"data-name": "Rectangle 79",
								width: 2.993,
								height: .998,
								rx: .499,
								transform: "translate(83.73 16.528)",
								fill: "#bac3d0"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_80",
								"data-name": "Rectangle 80",
								width: 13.304,
								height: 1.33,
								rx: .665,
								transform: "translate(9.893 26.173)",
								fill: "#707070"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_81",
								"data-name": "Rectangle 81",
								width: 4.324,
								height: .665,
								rx: .333,
								transform: "translate(14.882 29.499)",
								fill: "#b0d7ef"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_82",
								"data-name": "Rectangle 82",
								width: 1.33,
								height: 1.663,
								rx: .665,
								transform: "translate(16.545 32.16)",
								fill: "#002c75"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_83",
								"data-name": "Rectangle 83",
								width: 9.645,
								height: 1.33,
								rx: .665,
								transform: "translate(31.845 26.173)",
								fill: "#707070"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_84",
								"data-name": "Rectangle 84",
								width: 4.324,
								height: .665,
								rx: .333,
								transform: "translate(34.838 29.499)",
								fill: "#b0d7ef"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_85",
								"data-name": "Rectangle 85",
								width: 1.33,
								height: 1.663,
								rx: .665,
								transform: "translate(36.501 32.16)",
								fill: "#002c75"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_86",
								"data-name": "Rectangle 86",
								width: 10.311,
								height: 1.33,
								rx: .665,
								transform: "translate(55.792 25.841)",
								fill: "#707070"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_87",
								"data-name": "Rectangle 87",
								width: 4.324,
								height: .665,
								rx: .333,
								transform: "translate(58.785 29.167)",
								fill: "#b0d7ef"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_88",
								"data-name": "Rectangle 88",
								width: 1.33,
								height: 1.663,
								rx: .665,
								transform: "translate(60.448 31.828)",
								fill: "#002c75"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_89",
								"data-name": "Rectangle 89",
								width: 9.645,
								height: 1.33,
								rx: .665,
								transform: "translate(74.085 25.841)",
								fill: "#707070"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_90",
								"data-name": "Rectangle 90",
								width: 4.324,
								height: .665,
								rx: .333,
								transform: "translate(77.078 29.167)",
								fill: "#b0d7ef"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_91",
								"data-name": "Rectangle 91",
								width: 1.33,
								height: 1.663,
								rx: .665,
								transform: "translate(78.741 31.828)",
								fill: "#002c75"
							}),
							/* @__PURE__ */ _jsx("ellipse", {
								id: "Ellipse_21",
								"data-name": "Ellipse 21",
								cx: 2.494,
								cy: 2.328,
								rx: 2.494,
								ry: 2.328,
								transform: "translate(94.04 27.171)",
								fill: "#f8b8ce"
							})
						]
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_260",
						"data-name": "Group 260",
						transform: "translate(125.179 51.996)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group_259",
							"data-name": "Group 259",
							transform: "translate(0 0)",
							children: [
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_121",
									"data-name": "Rectangle 121",
									width: 166.814,
									height: 55.477,
									rx: 27.739,
									fill: "#fff"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_92",
									"data-name": "Rectangle 92",
									width: 31.373,
									height: 5.739,
									rx: 2.87,
									transform: "translate(5.356 3.443)",
									fill: "#eff0fa"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_93",
									"data-name": "Rectangle 93",
									width: 22.681,
									height: 1.89,
									rx: .945,
									transform: "translate(6.897 12.158)",
									fill: "#002c74"
								}),
								/* @__PURE__ */ _jsx("line", {
									id: "Line_9",
									"data-name": "Line 9",
									y2: 1.148,
									transform: "translate(30.991 12.626)",
									fill: "none",
									stroke: "#00d6c6",
									strokeWidth: 1
								}),
								/* @__PURE__ */ _jsx("line", {
									id: "Line_10",
									"data-name": "Line 10",
									y1: .709,
									x2: .473,
									transform: "translate(30.641 12.512)",
									fill: "none",
									stroke: "#00d6c6",
									strokeWidth: 1
								}),
								/* @__PURE__ */ _jsx("line", {
									id: "Line_11",
									"data-name": "Line 11",
									x1: .473,
									y1: .709,
									transform: "translate(31.113 12.512)",
									fill: "none",
									stroke: "#00d6c6",
									strokeWidth: 1
								}),
								/* @__PURE__ */ _jsx("circle", {
									id: "Ellipse_22",
									"data-name": "Ellipse 22",
									cx: .118,
									cy: .118,
									r: .118,
									transform: "translate(30.995 12.394)",
									fill: "#00d6c6"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_94",
									"data-name": "Rectangle 94",
									width: 17.217,
									height: 1.53,
									rx: .765,
									transform: "translate(40.938 12.243)",
									fill: "#002c74"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_95",
									"data-name": "Rectangle 95",
									width: 8.8,
									height: 1.913,
									rx: .957,
									transform: "translate(40.938 14.921)",
									fill: "#002c74"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_96",
									"data-name": "Rectangle 96",
									width: 11.095,
									height: 1.913,
									rx: .957,
									transform: "translate(67.72 12.626)",
									fill: "#002c74"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_97",
									"data-name": "Rectangle 97",
									width: 18.365,
									height: 1.913,
									rx: .957,
									transform: "translate(88.381 12.626)",
									fill: "#002c74"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_98",
									"data-name": "Rectangle 98",
									width: 12.626,
									height: 1.913,
									rx: .957,
									transform: "translate(116.311 12.626)",
									fill: "#002c74"
								}),
								/* @__PURE__ */ _jsx("line", {
									id: "Line_12",
									"data-name": "Line 12",
									x2: 1.065,
									y2: 1.065,
									transform: "translate(8.636 6.529)",
									fill: "none",
									stroke: "#5266a5",
									strokeWidth: 1
								}),
								/* @__PURE__ */ _jsxs("g", {
									id: "Ellipse_23",
									"data-name": "Ellipse 23",
									transform: "translate(7.251 5.145)",
									fill: "none",
									stroke: "#5266a5",
									strokeWidth: 1,
									children: [/* @__PURE__ */ _jsx("ellipse", {
										cx: .902,
										cy: .902,
										rx: .902,
										ry: .902,
										stroke: "none"
									}), /* @__PURE__ */ _jsx("ellipse", {
										cx: .902,
										cy: .902,
										rx: .402,
										ry: .402,
										fill: "none"
									})]
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_99",
									"data-name": "Rectangle 99",
									width: 10.632,
									height: 1.89,
									rx: .945,
									transform: "translate(7.606 20.781)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_100",
									"data-name": "Rectangle 100",
									width: 10.632,
									height: 1.89,
									rx: .945,
									transform: "translate(41.036 20.781)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_101",
									"data-name": "Rectangle 101",
									width: 12.522,
									height: 1.89,
									rx: .945,
									transform: "translate(68.206 20.781)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_102",
									"data-name": "Rectangle 102",
									width: 10.632,
									height: 1.89,
									rx: .945,
									transform: "translate(68.206 23.616)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_103",
									"data-name": "Rectangle 103",
									width: 6.143,
									height: 1.89,
									rx: .945,
									transform: "translate(88.524 20.781)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_104",
									"data-name": "Rectangle 104",
									width: 7.269,
									height: 4.209,
									rx: 2.104,
									transform: "translate(119.372 20.66)",
									fill: "#ffc0d0"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_105",
									"data-name": "Rectangle 105",
									width: 10.632,
									height: 1.89,
									rx: .945,
									transform: "translate(7.606 31.413)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_106",
									"data-name": "Rectangle 106",
									width: 6.615,
									height: 1.89,
									rx: .945,
									transform: "translate(41.036 31.413)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_107",
									"data-name": "Rectangle 107",
									width: 12.522,
									height: 1.89,
									rx: .945,
									transform: "translate(68.206 31.413)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_109",
									"data-name": "Rectangle 109",
									width: 6.143,
									height: 1.89,
									rx: .945,
									transform: "translate(88.524 31.413)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_110",
									"data-name": "Rectangle 110",
									width: 7.269,
									height: 3.826,
									rx: 1.913,
									transform: "translate(119.372 30.608)",
									fill: "#fef19a"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_111",
									"data-name": "Rectangle 111",
									width: 152.275,
									height: .383,
									rx: .191,
									transform: "translate(6.887 27.93)",
									fill: "#b0d7ee"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_112",
									"data-name": "Rectangle 112",
									width: 152.275,
									transform: "translate(6.887 36.347)",
									fill: "#b0d7ee"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_113",
									"data-name": "Rectangle 113",
									width: 18.365,
									height: 1.913,
									rx: .957,
									transform: "translate(138.119 12.626)",
									fill: "#002c74"
								}),
								/* @__PURE__ */ _jsx("ellipse", {
									id: "Ellipse_24",
									"data-name": "Ellipse 24",
									cx: .383,
									cy: .191,
									rx: .383,
									ry: .191,
									transform: "translate(147.302 21.808)",
									fill: "#00d6c6"
								}),
								/* @__PURE__ */ _jsx("ellipse", {
									id: "Ellipse_25",
									"data-name": "Ellipse 25",
									cx: .383,
									cy: .191,
									rx: .383,
									ry: .191,
									transform: "translate(147.302 22.573)",
									fill: "#00d6c6"
								}),
								/* @__PURE__ */ _jsx("circle", {
									id: "Ellipse_26",
									"data-name": "Ellipse 26",
									cx: .383,
									cy: .383,
									r: .383,
									transform: "translate(147.302 23.721)",
									fill: "#00d6c6"
								}),
								/* @__PURE__ */ _jsx("ellipse", {
									id: "Ellipse_27",
									"data-name": "Ellipse 27",
									cx: .383,
									cy: .191,
									rx: .383,
									ry: .191,
									transform: "translate(147.302 31.373)",
									fill: "#00d6c6"
								}),
								/* @__PURE__ */ _jsx("circle", {
									id: "Ellipse_28",
									"data-name": "Ellipse 28",
									cx: .383,
									cy: .383,
									r: .383,
									transform: "translate(147.302 32.139)",
									fill: "#00d6c6"
								}),
								/* @__PURE__ */ _jsx("ellipse", {
									id: "Ellipse_29",
									"data-name": "Ellipse 29",
									cx: .383,
									cy: .574,
									rx: .383,
									ry: .574,
									transform: "translate(147.302 33.286)",
									fill: "#00d6c6"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_114",
									"data-name": "Rectangle 114",
									width: 10.632,
									height: 1.89,
									rx: .945,
									transform: "translate(7.606 40.036)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_115",
									"data-name": "Rectangle 115",
									width: 10.713,
									height: 1.53,
									rx: .765,
									transform: "translate(40.938 40.173)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_116",
									"data-name": "Rectangle 116",
									width: 12.626,
									height: 1.53,
									rx: .765,
									transform: "translate(68.103 40.173)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_117",
									"data-name": "Rectangle 117",
									width: 10.713,
									height: 2.296,
									rx: 1.148,
									transform: "translate(68.103 42.851)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_118",
									"data-name": "Rectangle 118",
									width: 6.122,
									height: 1.53,
									rx: .765,
									transform: "translate(88.381 40.173)",
									fill: "#365d97"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_119",
									"data-name": "Rectangle 119",
									width: 7.088,
									height: 3.78,
									rx: 1.89,
									transform: "translate(119.474 40.154)",
									fill: "#ffc0d0"
								}),
								/* @__PURE__ */ _jsx("circle", {
									id: "Ellipse_30",
									"data-name": "Ellipse 30",
									cx: .354,
									cy: .354,
									r: .354,
									transform: "translate(147.589 40.627)",
									fill: "#00d6c6"
								}),
								/* @__PURE__ */ _jsx("circle", {
									id: "Ellipse_31",
									"data-name": "Ellipse 31",
									cx: .354,
									cy: .354,
									r: .354,
									transform: "translate(147.589 41.808)",
									fill: "#00d6c6"
								}),
								/* @__PURE__ */ _jsx("circle", {
									id: "Ellipse_32",
									"data-name": "Ellipse 32",
									cx: .354,
									cy: .354,
									r: .354,
									transform: "translate(147.589 42.989)",
									fill: "#00d6c6"
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_120",
									"data-name": "Rectangle 120",
									width: 152.275,
									height: .765,
									rx: .383,
									transform: "translate(7.652 47.06)",
									fill: "#b0d7ee"
								})
							]
						})
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_319",
						"data-name": "Group 319",
						transform: "translate(110.001 7.023)",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Path_1155",
							"data-name": "Path 1155",
							d: "M10.042,0H37.407A10.042,10.042,0,0,1,47.449,10.042v5.544A10.025,10.025,0,0,1,37.407,25.607H10.042A10.042,10.042,0,0,1,0,15.565V10.042A10.042,10.042,0,0,1,10.042,0Z",
							transform: "translate(0 0)",
							fill: "#fff"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_1154",
							"data-name": "Path 1154",
							d: "M-202.4-106.741c2.6-5.74,11.861-6.587,16.921-5.318,3.117,2.079,3.376,4.033,4.149,6.755.15,5.948.659,7.456-1.008,11.966-2.193,3.71-4.706,4.322-6.446,5.125-5.245.906-1.2-.429-15.932.284-4.431.236-8.565-.067-11.989,0-3.14-.072-3.8.241-7.067-1.408a12.419,12.419,0,0,1-3.109-2.916,8.471,8.471,0,0,1-1.669-6.006c.281,7.7,28.741,10.963,31.585,6.2C-192.546-99.153-205.152-99.739-202.4-106.741Z",
							transform: "translate(228.72 113.81)",
							fill: "#eff0fa"
						})]
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_122",
						"data-name": "Rectangle 122",
						width: 14.264,
						height: 3.17,
						rx: 1.585,
						transform: "translate(118.047 18.424)",
						fill: "#aed7ed"
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_334",
						"data-name": "Group 334",
						transform: "translate(0 0)",
						children: /* @__PURE__ */ _jsxs("g", {
							id: "Group_325",
							"data-name": "Group 325",
							children: [
								/* @__PURE__ */ _jsxs("g", {
									id: "Group_321",
									"data-name": "Group 321",
									transform: "translate(0 23.318)",
									children: [
										/* @__PURE__ */ _jsx("path", {
											id: "Path_1159",
											"data-name": "Path 1159",
											d: "M2753.281,1537.236l1.813-.259c-.239-17.536-.45-42.794-.051-44.288a.541.541,0,0,1-.12.2l-1.471-.851c-.238.265-.381.425-.431,7.883-.025,3.838-.015,9.138.029,15.752C2753.126,1526.934,2753.28,1537.124,2753.281,1537.236Z",
											transform: "translate(-2726.637 -1429.544)",
											fill: "#0e2e35"
										}),
										/* @__PURE__ */ _jsx("g", {
											id: "Group_320",
											"data-name": "Group 320",
											transform: "translate(5.567 21.064)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_1160",
												"data-name": "Path 1160",
												d: "M2871.854,1237.972l.974-.824c-3.566-4.207-5.527-12.224-5.671-23.185a115.525,115.525,0,0,1,.895-15.594l-1.264-.177a116.924,116.924,0,0,0-.907,15.771,68.892,68.892,0,0,0,1.285,13.13C2868.163,1231.818,2869.741,1235.478,2871.854,1237.972Z",
												transform: "translate(-2865.873 -1198.192)",
												fill: "#0e2e35"
											})
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_1161",
											"data-name": "Path 1161",
											d: "M2810.16,1049.619c-.527,0-20.175-2.131-20.526.5s-1.055,23.171,2.46,23.873,20.565-2.458,20.565-2.458Z",
											transform: "translate(-2789.331 -1048.805)",
											fill: "#002c75"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_1162",
											"data-name": "Path 1162",
											d: "M2661.344,1444.156c-.759-.151,1.933,2.633,0,3.511s-31.111.351-33.4-.7-5.1-2.809-4.042-5.091,19.035-5.266,19.035-5.266l16.294,4.389S2662.223,1444.332,2661.344,1444.156Z",
											transform: "translate(-2615.342 -1381.928)",
											fill: "#002c75"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Rectangle_123",
											"data-name": "Rectangle 123",
											d: "M1.8,0H23.408a1.8,1.8,0,0,1,1.8,1.8v0a.315.315,0,0,1-.315.315H.314A.314.314,0,0,1,0,1.8v0A1.8,1.8,0,0,1,1.8,0Z",
											transform: "translate(14.871 106.377)",
											fill: "#002c75"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Rectangle_124",
											"data-name": "Rectangle 124",
											d: "M1.416,0h2.65A1.416,1.416,0,0,1,5.482,1.416v0A1.416,1.416,0,0,1,4.066,2.832H1.416A1.416,1.416,0,0,1,0,1.416v0A1.416,1.416,0,0,1,1.416,0Z",
											transform: "translate(24.669 104.602)",
											fill: "#002c75"
										})
									]
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1163",
									"data-name": "Path 1163",
									d: "M2414.025,1360.952c-.581-.29-16.131-11.181-16.131-11.181l19.033-1.862s29.758,4.067,34.1,7.68c.313.26.6.51.865.749a5.747,5.747,0,0,1,.881,7.5c-2.933,4.306-1.1,3.857-6.084,10.931-5.9,8.366-19.719,24.958-19.719,24.958h0c-1.673,2.05-3.951,4.905-3.975,5.279-.037.592-.119,6.137.556,6.729s1.776,1.339,1.572,1.729c-.324.616-2.083.585-4.54.449-.718-.039-2.929-5.085-3.214-5.926-.412-1.22-1.416-3.969-1.041-4.819a7.156,7.156,0,0,1,2.29-2.061c.787-.507,2.922-3.245,4.479-5.318,0,0,14.182-26.509,15.646-27.545s7.206-7.581,7.206-7.581-9.577,3.623-10.012,3.623S2414.605,1361.241,2414.025,1360.952Z",
									transform: "translate(-2375.182 -1282.418)",
									fill: "#f48c7f"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1164",
									"data-name": "Path 1164",
									d: "M2593.118,1725.96s3.577,9.759,5.07,10.276c.4.137,2.749.885,3.107,1.725a3.626,3.626,0,0,1,0,1.1h-7.16a21.447,21.447,0,0,1-1.514-4.4s-2.955-6.868-2.775-7.352C2590.385,1725.862,2593.118,1725.96,2593.118,1725.96Z",
									transform: "translate(-2549.851 -1607.163)",
									fill: "#0e2e35"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1165",
									"data-name": "Path 1165",
									d: "M2197.3,1357.585s16.469-1.594,22.128,0,28.44,8.55,30.036,10.289,22.2,43.141,22.21,43.162a38.533,38.533,0,0,0,2.713,4.769,9.5,9.5,0,0,0,1.955,1.821c.285.173,1.187.674,1.4.778a29.2,29.2,0,0,1,5.2,2.867c.636.466.735.448-.052.436l-12.653-.515s-1.427.285-1.985-.755-.186-2.224.033-3.328a4.781,4.781,0,0,0-.914-3.327c-2.024-3.413-17.421-21.209-20.623-26.843-3.213-5.655-4.128-9.253-4.242-10.934-9.577,0-37.624-.2-42.521-4.76S2197.3,1357.585,2197.3,1357.585Z",
									transform: "translate(-2176.47 -1290.121)",
									fill: "#f7a491"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1166",
									"data-name": "Path 1166",
									d: "M2197.353,1785.979a12.9,12.9,0,0,1-8.143-.286c-.408,1.152-1.04,2.561-.753,3.395.351,1.021.851,1.251,1.293,1.263,3.494.091,12.8.216,15.462.25a.434.434,0,0,0,.338-.713C2204.89,1789.1,2197.639,1786.153,2197.353,1785.979Z",
									transform: "translate(-2097.482 -1658.474)",
									fill: "#0e2e35"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1167",
									"data-name": "Path 1167",
									d: "M2432.241,1347.514s29.777,4.125,34.118,7.739a5.957,5.957,0,0,1,.515.5,10.838,10.838,0,0,0-1.246-.557s-6.849-.434-12.4,8.047a18.92,18.92,0,0,1-1.979.648c-.435,0-21.33-3.044-21.91-3.333s-16.131-11.181-16.131-11.181Z",
									transform: "translate(-2390.444 -1282.078)",
									fill: "#b0d7ee"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1168",
									"data-name": "Path 1168",
									d: "M2473.035,1357.585s16.469-1.594,22.128,0c4.19,1.18,17.762,5.3,25.177,8.064-2.622,1.8-5.523,4.922-7.85,10.356-12.325.019-33.689-.221-37.823-4.073C2469.77,1367.367,2473.035,1357.585,2473.035,1357.585Z",
									transform: "translate(-2452.206 -1290.121)",
									fill: "#b0d7ee"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1169",
									"data-name": "Path 1169",
									d: "M2455.528,1122.317l-17.374-3.839s-6.283-8.062-12.317-15c-1.776,1.755-2.763,4.452-4.551,6.19l13.264,14.652a2.535,2.535,0,0,0,1.871.833l18.413.061,6.3.5v-4.027Z",
									transform: "translate(-2385.845 -1072.45)",
									fill: "#f48c7f"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1170",
									"data-name": "Path 1170",
									d: "M2589.667,1085.971c3.038-.8,15.2,17.448,15.2,17.448s-1.648.764-4.582,4.76L2595.6,1103l-.008.009s-9.317-8.788-11.086-11.847S2586.628,1086.776,2589.667,1085.971Z",
									transform: "translate(-2552.563 -1057.391)",
									fill: "#b0d7ee"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1171",
									"data-name": "Path 1171",
									d: "M2667.535,890.867c-.074-.148-.119-.228-.119-.228l.007-.062c-.219-.541-.458-1.078-.721-1.611-1.742-3.529-6.055-5.531-9.987-5.536a12.54,12.54,0,0,0-3.518.477c-1.61.723-5.547,3.224-6.571,10.675a11.935,11.935,0,0,0,1.423,7.48,8.984,8.984,0,0,0-3.46,4.73c-1.852,4.995-11.114,6.105-12.041,12.765s8.707,18.685,18.895,10.915c7.756-5.915,6.495-17.187,5.45-22.234a11.381,11.381,0,0,0,7.516-1.63,9.454,9.454,0,0,0,4.814-7.039A25.781,25.781,0,0,0,2667.535,890.867Z",
									transform: "translate(-2623.751 -883.43)",
									fill: "#0e2e35"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1172",
									"data-name": "Path 1172",
									d: "M2658.63,1068.575s-6.172-1.217-8.988,1.133.6,23.243.6,26.707-1.934,13.249-1.934,13.249,18.706,3.27,21.677-1.929c0,0,.845-19.809.719-22.3s-.924-9.885-3.666-13.77C2666.271,1070.575,2658.63,1068.575,2658.63,1068.575Z",
									transform: "translate(-2627.479 -1042.199)",
									fill: "#b0d7ee"
								}),
								/* @__PURE__ */ _jsx("g", {
									id: "Group_322",
									"data-name": "Group 322",
									transform: "translate(23.358 17.876)",
									children: /* @__PURE__ */ _jsx("path", {
										id: "Path_1173",
										"data-name": "Path 1173",
										d: "M2717.577,1017.056c-6.312,0-10.809-5.707-11-5.95a.555.555,0,1,1,.879-.68h0c.043.055,4.358,5.52,10.119,5.52a.555.555,0,1,1,0,1.11Z",
										transform: "translate(-2706.463 -1010.211)",
										fill: "#618cf6"
									})
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1174",
									"data-name": "Path 1174",
									d: "M2696.737,1002.025s-.033.184-.091.5c-.28,1.5-1.358,6.495-2.086,7.867-.88,1.658,3.013,6.946,6.76,6.3,1.115-.192-.943-4.859-.844-5.353.19-.947.446-2.237.709-3.561.148-.747.3-1.5.439-2.216.4-2.022.728-3.676.728-3.676Z",
									transform: "translate(-2665.625 -985.183)",
									fill: "#f7a491"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1175",
									"data-name": "Path 1175",
									d: "M2694.6,1002.522c.058-.314.091-.5.091-.5l5.615-.14s-.327,1.654-.728,3.676l-.437,2.2a5.264,5.264,0,0,1-2.68-1.339,7.059,7.059,0,0,1-2.031-3.01C2694.5,1003.061,2694.561,1002.756,2694.6,1002.522Z",
									transform: "translate(-2663.583 -985.183)",
									fill: "#f47458"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1176",
									"data-name": "Path 1176",
									d: "M2533.423,1122.317l-17.373-3.839s-6.283-8.062-12.317-15c-1.776,1.755-2.763,4.452-4.551,6.19l13.264,14.652a2.535,2.535,0,0,0,1.871.833l18.413.061,6.3.5v-4.027Z",
									transform: "translate(-2474.739 -1072.45)",
									fill: "#f7a491"
								}),
								/* @__PURE__ */ _jsxs("g", {
									id: "Group_323",
									"data-name": "Group 323",
									transform: "translate(38.576 30.116)",
									children: [/* @__PURE__ */ _jsx("path", {
										id: "Path_1177",
										"data-name": "Path 1177",
										d: "M2328.65,1097.018H2300a1.868,1.868,0,0,0-1.729,1.158l-8.823,21.49h-15.8a.8.8,0,0,0-.8.8h0a.8.8,0,0,0,.8.8h44.958a3.139,3.139,0,0,0,2.863-1.851l8.884-19.763A1.866,1.866,0,0,0,2328.65,1097.018Z",
										transform: "translate(-2272.85 -1097.018)",
										fill: "#002c75"
									}), /* @__PURE__ */ _jsx("path", {
										id: "Path_1178",
										"data-name": "Path 1178",
										d: "M2398.187,1173.091a1.576,1.576,0,1,1-1.182-2.054A1.685,1.685,0,0,1,2398.187,1173.091Z",
										transform: "translate(-2357.815 -1160.577)",
										fill: "#002c75"
									})]
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1179",
									"data-name": "Path 1179",
									d: "M2662.6,905.9a5.89,5.89,0,0,0-4.927,2.045c-1.9,2.385-3.945,9.759.772,13.768s9.377-.529,10.067-5.341S2669.467,905.724,2662.6,905.9Z",
									transform: "translate(-2626.626 -902.716)",
									fill: "#f7a491"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1180",
									"data-name": "Path 1180",
									d: "M2707.614,899.956s-4.047,7.013-6.941,7.337-3.275,4.05-3.275,4.05,1.035-8.586,3.9-10.242A10.927,10.927,0,0,1,2707.614,899.956Z",
									transform: "translate(-2671.306 -897.562)",
									fill: "#0e2e35"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1181",
									"data-name": "Path 1181",
									d: "M2743.788,952.887c.235,1.245-.239,2.387-1.058,2.551s-1.675-.714-1.91-1.959.238-2.387,1.058-2.551S2743.552,951.641,2743.788,952.887Z",
									transform: "translate(-2713.663 -941.394)",
									fill: "#f7a491"
								}),
								/* @__PURE__ */ _jsx("path", {
									id: "Path_1182",
									"data-name": "Path 1182",
									d: "M2665.528,1071.367c3.038-.8,12.952,13.749,12.953,13.75,2.7,3.33,4.585,5.751,4.585,5.751s-1.648.764-4.583,4.761l-4.688-5.178-.007.009s-9.316-8.788-11.086-11.847A4.8,4.8,0,0,1,2665.528,1071.367Z",
									transform: "translate(-2641.755 -1044.84)",
									fill: "#b0d7ee"
								}),
								/* @__PURE__ */ _jsxs("g", {
									id: "Group_324",
									"data-name": "Group 324",
									transform: "translate(62.359 55.721)",
									children: [
										/* @__PURE__ */ _jsx("path", {
											id: "Rectangle_125",
											"data-name": "Rectangle 125",
											d: "M1.8,0H23.408a1.8,1.8,0,0,1,1.8,1.8v0a.315.315,0,0,1-.315.315H.315A.315.315,0,0,1,0,1.8v0A1.8,1.8,0,0,1,1.8,0Z",
											transform: "translate(0 73.996)",
											fill: "#0e2e35"
										}),
										/* @__PURE__ */ _jsx("rect", {
											id: "Rectangle_126",
											"data-name": "Rectangle 126",
											width: 2.741,
											height: 73.895,
											transform: "translate(11.169)",
											fill: "#0e2e35"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Rectangle_127",
											"data-name": "Rectangle 127",
											d: "M1.416,0h2.65A1.416,1.416,0,0,1,5.482,1.416v0A1.416,1.416,0,0,1,4.066,2.832H1.416A1.416,1.416,0,0,1,0,1.416v0A1.416,1.416,0,0,1,1.416,0Z",
											transform: "translate(9.798 72.221)",
											fill: "#0e2e35"
										})
									]
								}),
								/* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_128",
									"data-name": "Rectangle 128",
									width: 85.228,
									height: 2.752,
									transform: "translate(32.349 54.345)",
									fill: "#0e2e35"
								})
							]
						})
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_10187",
				"data-name": "Group 10187",
				transform: "translate(970.663 377.982)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_12762",
						"data-name": "Path 12762",
						d: "M2558.248,902.584l2.692-1.459a.679.679,0,0,1,.707.044q.4.281.826.533a11.414,11.414,0,0,0,1.622.795.67.67,0,0,1,.429.621l.036,3.2a.657.657,0,0,0,.613.651l2.916.22a.65.65,0,0,0,.686-.527l.538-2.9a.652.652,0,0,1,.571-.536,11.828,11.828,0,0,0,3.579-1.049.674.674,0,0,1,.8.181l1.139,1.383a.681.681,0,0,0,.889.136l2.423-1.6a.589.589,0,0,0,.132-.112.653.653,0,0,0,.087-.755l-1.087-2.012-.266-.49a11.83,11.83,0,0,0,1.876-3.361.652.652,0,0,1,.609-.436l2.578-.026a.676.676,0,0,0,.667-.627l.169-2.23.047-.639a.685.685,0,0,0-.557-.727l-2.42-.451a.651.651,0,0,1-.537-.549,11.8,11.8,0,0,0-.642-2.428c-.021-.07-.046-.132-.073-.2a.337.337,0,0,1-.023-.067.668.668,0,0,1,.222-.707l2.242-1.855a.484.484,0,0,0,.071-.067.679.679,0,0,0,.063-.819l-1.593-2.418a.676.676,0,0,0-.885-.222l-2.807,1.523a.653.653,0,0,1-.736-.073,11.942,11.942,0,0,0-1.491-1.036q-.424-.249-.858-.458a.687.687,0,0,1-.388-.612l-.036-3.075a.657.657,0,0,0-.607-.648l-2.886-.213a.686.686,0,0,0-.729.56l-.426,2.292a.674.674,0,0,1-.623.552,11.79,11.79,0,0,0-3.559.747.67.67,0,0,1-.762-.2l-1.671-2.022a.693.693,0,0,0-.911-.137l-2.41,1.586a.662.662,0,0,0-.218.871l.062.118,1.264,2.337a.677.677,0,0,1-.083.769l0,0a11.763,11.763,0,0,0-1.209,1.692c-.191.325-.362.655-.521.991a.665.665,0,0,1-.6.389l-2.616.026a.687.687,0,0,0-.68.635l-.214,2.874a.752.752,0,0,0,.024.235.683.683,0,0,0,.524.479l1.934.355a.684.684,0,0,1,.511.436.712.712,0,0,1,.038.185,11.752,11.752,0,0,0,1.176,4.5.662.662,0,0,1-.091.721.741.741,0,0,1-.082.08l-1.817,1.5a.672.672,0,0,0-.134.886l.036.056,1.551,2.358a.684.684,0,0,0,.9.221m14.8-15.31a7.848,7.848,0,0,1,.91,1.148,6.175,6.175,0,0,1,.845,3.261c-.007.1-.017.207-.027.31a6.387,6.387,0,0,1-12.742.065,4.13,4.13,0,0,1,0-.62,7.279,7.279,0,0,1,.6-2.4,6.342,6.342,0,0,1,10.418-1.765",
						transform: "translate(-2506.741 -845.261)",
						fill: "#aec3ff"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_12763",
						"data-name": "Path 12763",
						d: "M2556.576,893.034l1.707-.925a.431.431,0,0,1,.448.028q.253.178.524.338a7.238,7.238,0,0,0,1.028.5.426.426,0,0,1,.272.393l.023,2.029a.416.416,0,0,0,.388.413l1.85.14a.412.412,0,0,0,.435-.334l.341-1.837a.414.414,0,0,1,.362-.34,7.487,7.487,0,0,0,2.269-.665.428.428,0,0,1,.508.114l.722.877a.432.432,0,0,0,.564.086l1.536-1.016a.374.374,0,0,0,.084-.071.414.414,0,0,0,.055-.479l-.69-1.276-.168-.311a7.5,7.5,0,0,0,1.19-2.131.413.413,0,0,1,.386-.276l1.634-.017a.429.429,0,0,0,.423-.4l.107-1.414.03-.405a.435.435,0,0,0-.353-.461l-1.535-.286a.414.414,0,0,1-.341-.348,7.43,7.43,0,0,0-.407-1.539c-.013-.045-.03-.084-.046-.126a.246.246,0,0,1-.014-.043.423.423,0,0,1,.141-.448l1.422-1.176a.355.355,0,0,0,.044-.043.431.431,0,0,0,.04-.519l-1.01-1.533a.428.428,0,0,0-.561-.141l-1.78.965a.414.414,0,0,1-.467-.046,7.57,7.57,0,0,0-.945-.657c-.179-.105-.361-.2-.544-.291a.435.435,0,0,1-.246-.388l-.023-1.95a.416.416,0,0,0-.385-.411l-1.829-.135a.435.435,0,0,0-.462.355l-.27,1.453a.428.428,0,0,1-.4.35,7.474,7.474,0,0,0-2.257.474.424.424,0,0,1-.483-.127l-1.06-1.282a.439.439,0,0,0-.577-.087l-1.529,1.006a.42.42,0,0,0-.138.552l.04.075.8,1.482a.43.43,0,0,1-.053.487v0a7.485,7.485,0,0,0-.766,1.073c-.122.206-.23.415-.33.628a.421.421,0,0,1-.379.247l-1.658.017a.436.436,0,0,0-.431.4l-.136,1.823a.475.475,0,0,0,.016.149.434.434,0,0,0,.332.3l1.227.225a.434.434,0,0,1,.324.277.442.442,0,0,1,.024.117,7.451,7.451,0,0,0,.746,2.852.42.42,0,0,1-.058.457.445.445,0,0,1-.052.051l-1.152.952a.427.427,0,0,0-.086.562l.024.036.983,1.5a.434.434,0,0,0,.569.14m9.385-9.707a4.994,4.994,0,0,1,.577.728,3.916,3.916,0,0,1,.536,2.068c0,.066-.011.131-.017.2a4.05,4.05,0,0,1-8.08.041,2.669,2.669,0,0,1,0-.393,4.611,4.611,0,0,1,.379-1.52,4.021,4.021,0,0,1,6.606-1.119",
						transform: "translate(-2545.16 -823.587)",
						fill: "#7284fa"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_12767",
						"data-name": "Path 12767",
						d: "M309.878,902.225l3.674-1.992a.927.927,0,0,1,.965.06q.544.384,1.128.727a15.528,15.528,0,0,0,2.213,1.085.914.914,0,0,1,.586.847l.049,4.367a.9.9,0,0,0,.837.889l3.982.3a.887.887,0,0,0,.936-.719l.734-3.954a.891.891,0,0,1,.78-.732,16.158,16.158,0,0,0,4.885-1.432.919.919,0,0,1,1.093.246l1.555,1.889a.929.929,0,0,0,1.214.185l3.307-2.186a.808.808,0,0,0,.18-.153.892.892,0,0,0,.119-1.03l-1.484-2.746-.363-.669a15.943,15.943,0,0,0,1.28-1.861,16.2,16.2,0,0,0,1.282-2.727.891.891,0,0,1,.832-.6l3.518-.036a.923.923,0,0,0,.911-.856l.231-3.044.064-.872a.935.935,0,0,0-.76-.992l-3.3-.616a.89.89,0,0,1-.734-.749,16.032,16.032,0,0,0-.875-3.314,2.794,2.794,0,0,0-.1-.27.492.492,0,0,1-.031-.092.912.912,0,0,1,.3-.965l3.061-2.532a.676.676,0,0,0,.1-.091.927.927,0,0,0,.087-1.118l-2.174-3.3a.923.923,0,0,0-1.208-.3l-3.831,2.079a.891.891,0,0,1-1.005-.1,16.31,16.31,0,0,0-2.035-1.414q-.578-.34-1.171-.626a.939.939,0,0,1-.53-.835l-.049-4.2a.9.9,0,0,0-.829-.884l-3.939-.291a.937.937,0,0,0-.994.764l-.582,3.129a.92.92,0,0,1-.85.753,16.1,16.1,0,0,0-4.859,1.019.914.914,0,0,1-1.04-.274l-2.281-2.76a.946.946,0,0,0-1.244-.187l-3.289,2.165a.9.9,0,0,0-.3,1.19l.085.161,1.726,3.19a.925.925,0,0,1-.115,1.049l0,0a16.025,16.025,0,0,0-1.65,2.31c-.261.444-.494.894-.711,1.354a.907.907,0,0,1-.815.531l-3.571.036a.938.938,0,0,0-.928.867l-.292,3.923a1.011,1.011,0,0,0,.033.321.934.934,0,0,0,.716.654l2.64.485a.933.933,0,0,1,.7.6.983.983,0,0,1,.052.253,16.051,16.051,0,0,0,1.6,6.14.9.9,0,0,1-.236,1.094l-2.48,2.049a.919.919,0,0,0-.183,1.21l.05.077,2.116,3.219a.935.935,0,0,0,1.224.3m20.205-20.9a10.743,10.743,0,0,1,1.242,1.567,8.436,8.436,0,0,1,1.154,4.451c-.01.142-.023.283-.037.422a8.719,8.719,0,0,1-17.394.088,5.652,5.652,0,0,1,0-.846,9.919,9.919,0,0,1,.814-3.272,8.657,8.657,0,0,1,14.221-2.41",
						transform: "translate(-303.641 -866.601)",
						fill: "#c6d9f5"
					})
				]
			})
		]
	})
});
export default SvgEmptyState;
